import { useEffect, useState } from "react"

export default function LikeButton({ post }) {
  const [liked, setLiked] = useState(post.liked_by_current_user)
  const [likesCount, setLikesCount] = useState(post.likes_count)
  const [submitting, setSubmitting] = useState(false)
  const [bursting, setBursting] = useState(false)

  useEffect(() => {
    setLiked(post.liked_by_current_user)
    setLikesCount(post.likes_count)
  }, [post.id, post.liked_by_current_user, post.likes_count])

  function handleClick(e) {
    e.preventDefault()

    if (submitting) return

    const nextLiked = !liked
    const nextCount = Math.max(0, likesCount + (nextLiked ? 1 : -1))
    setLiked(nextLiked)
    setLikesCount(nextCount)
    setSubmitting(true)

    if (nextLiked) {
      setBursting(false)
      requestAnimationFrame(() => {
        setBursting(true)
        setTimeout(() => setBursting(false), 700)
      })
    }

    const token = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(`/posts/${post.id}/like`, {
      method: nextLiked ? "POST" : "DELETE",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "X-CSRF-Token": token,
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .then(response => {
        if (!response.ok) throw new Error("Like request failed")
        return response.json()
      })
      .then(data => {
        setLiked(data.liked_by_current_user)
        setLikesCount(data.likes_count)
      })
      .catch(() => {
        setLiked(liked)
        setLikesCount(likesCount)
      })
      .finally(() => setSubmitting(false))
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={submitting}
      aria-pressed={liked}
      aria-label={liked ? "Unlike post" : "Like post"}
      data-burst={bursting ? "true" : "false"}
      className={`like-button relative inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs transition-colors disabled:cursor-wait ${
        liked
          ? "text-rose-400 hover:text-rose-300"
          : "text-stone-600 hover:text-rose-400"
      }`}
    >
      <span className="like-button__burst" aria-hidden="true">
        <span />
        <span />
        <span />
        <span />
      </span>
      <svg
        viewBox="0 0 24 24"
        aria-hidden="true"
        className={`h-4 w-4 transition-transform ${liked ? "fill-current" : "fill-transparent"}`}
      >
        <path
          d="M12 21s-7.2-4.5-9.5-9.3C.7 7.9 2.8 4 6.7 4c2 0 3.8 1.1 5.3 3 1.5-1.9 3.3-3 5.3-3 3.9 0 6 3.9 4.2 7.7C19.2 16.5 12 21 12 21Z"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinejoin="round"
        />
      </svg>
      <span>{likesCount}</span>
    </button>
  )
}
